import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';


import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { trackEvent } from '../../../lib/analytics';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';
import ModalWorkspaceMenu from '../../../components/Modals/ModalWorkspaceMenu/ModalWorkspaceMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';

import '../MainApp.scss';
import './Settings.scss';


function getSectionName(value = '') {
    switch (value) {
        case 'usage':
            return 'Usage';
        case 'billing':
            return 'Billing';
        case 'workspace':
            return 'Workspace';
        case 'profile':
            return 'Profile';
        case 'preferences':
            return 'Preferences';
        default:
            return 'Settings';
    }
}

const SECTIONS = ['usage', 'billing', 'workspace', 'profile', 'preferences'];


const Settings = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { section } = useParams();

    const activeSection = SECTIONS.includes(section) ? section : 'usage';
    const [selectedType, setSelectedType] = useState(activeSection);

    document.title = 'Settings - Usage - DB Design';

    useEffect(() => {
        document.title = `Settings - ${getSectionName(selectedType)} - DB Design`;
    }, [selectedType]);


    const handleSelectType = (value) => {
        trackEvent(`app_settings_select_${value}`, {
            page: 'app',
            type: 'settings',
        });
        if (value !== selectedType) {
            setSelectedType(value);
            history.replace(`/settings/${value}/`);
        }
    };

    return (
        <div className="dash-container settings-page">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />
                <ModalWorkspaceMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}

                <Header title='Settings'>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Request</button> */}
                </Header>

                <div className='dash-main-body'>

                    <div className='selection-group'>
                        <div className={`selection-item ${selectedType === 'usage' ? 'selected' : ''}`} onClick={() => handleSelectType('usage')}>Usage</div>
                        <div className={`selection-item ${selectedType === 'billing' ? 'selected' : ''}`} onClick={() => handleSelectType('billing')}>Billing</div>
                        <div className={`selection-item ${selectedType === 'workspace' ? 'selected' : ''}`} onClick={() => handleSelectType('workspace')}>Workspace</div>
                        <div className={`selection-item ${selectedType === 'profile' ? 'selected' : ''}`} onClick={() => handleSelectType('profile')}>Profile</div>
                        <div className={`selection-item ${selectedType === 'preferences' ? 'selected' : ''}`} onClick={() => handleSelectType('preferences')}>Preferences</div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Account Details</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    {/* <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Nickname</div>
                            <span className='section-left-subtitle'>This will be displayed on your profile. Visible for you and your team.</span>
                        </div>
                        <div className='section-right'></div>
                    </div> */}

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Name</div>
                            <span className='section-left-subtitle'>This will be displayed on your profile. Visible for you and your team.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Email address</div>
                            <span className='section-left-subtitle'>Your account email address.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>



                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Preferences</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Color Theme</div>
                            <span className='section-left-subtitle'>Select or customize your UI theme.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Language</div>
                            <span className='section-left-subtitle'>Select interface language.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Date Format</div>
                            <span className='section-left-subtitle'>Select date format.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>



                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title'>Dangerous Zone</div>
                            {/* <span className='section-left-subtitle'>Update your personal details here.</span> */}
                        </div>
                        <div className='section-right'></div>
                    </div>

                    <div className='dash-main-body-section'>
                        <div className='section-left'>
                            <div className='section-left-title two'>Delete Account</div>
                            <span className='section-left-subtitle'>Update your personal details here.</span>
                        </div>
                        <div className='section-right'></div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Settings;
